import React, { useCallback } from 'react';
import { Flex, IconChevronRight, Typography } from '@banhala/ui-kit';
import { isNil } from 'shared/src/utils';
import { useOpenDeeplink } from 'shared/src/hooks';
import { useConfigs } from 'shared/src/queries';
import { TitleContent } from './TitleContent';
import { DeliveryBadgeRow } from './DeliveryBadgeRow';
import { useDeliveryInfoMessage } from '../hooks/useDeliveryInfoMessage';
import { useLogClickTodayDelivery } from '../hooks/useLogClickTodayDelivery';

export const TodayDeliverySection = () => {
  const { data: configs } = useConfigs();
  const logClickTodayDelivery = useLogClickTodayDelivery();
  const deliveryInfoMessage = useDeliveryInfoMessage();
  const { openDeeplink } = useOpenDeeplink();

  const onPressTodayDeliveryMore = useCallback(() => {
    if (isNil(configs)) return;
    logClickTodayDelivery();
    openDeeplink(configs.today_delivery.department_deeplink);
  }, [configs, logClickTodayDelivery, openDeeplink]);

  return (
    <>
      <TitleContent title={'배송정보'}>
        <Flex gap={4}>
          <Flex.Row gap={8} alignItems={'center'}>
            <DeliveryBadgeRow testID={'오늘출발툴팁'} />
            <Flex.Row
              alignItems={'center'}
              justifyContent={'center'}
              padding={{ vertical: 6, left: 8, right: 6 }}
              onPress={onPressTodayDeliveryMore}
              borderWidth={1}
              borderColor={'border_tertiary'}
              borderRadius={16}
              testID={'오늘출발전체보기버튼'}
              gap={4}
            >
              <Typography type={'subtitle5'} color={'content_secondary'}>
                오늘출발 전체보기
              </Typography>
              <IconChevronRight size={12} />
            </Flex.Row>
          </Flex.Row>
        </Flex>
      </TitleContent>
      <TitleContent title={''}>
        <Typography type={'body2'}>{deliveryInfoMessage}</Typography>
      </TitleContent>
    </>
  );
};
